export const getSocials = globalsConfig => {
    return globalsConfig.filter(social => {
        return social.mobileOnly === false;
    });
};

export default getSocials;
